import { Theme } from '@surglogs-app/ui.theme'

export const mediaQueries = {
  md: ({ theme }: { theme: Theme }) => `@media ${theme.mq?.md}`,
  lg: ({ theme }: { theme: Theme }) => `@media ${theme.mq?.lg}`,
  xl: ({ theme }: { theme: Theme }) => `@media ${theme.mq?.xl}`,
  sideBarCollapsed: ({ theme }: { theme: Theme }) =>
    `@media ${theme.mq?.sideBarCollapsed}`,
}
